import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { DICTS } from "@/lib/i18n";

export const Route = createFileRoute("/account/install-app")({
  component: lazyRouteComponent(() => import("./-pages/account.install-app")),
  head: () => ({
    meta: [
      {
        title:
          DICTS.en["install.page.meta_title"] ??
          "Install the Lecmo app — Ambassadors",
      },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});
